// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"209":"54cdd6af","427":"9fc7949d","440":"f6a70c63","457":"001243aa","484":"335d1e88","815":"95c9e9fb","851":"5619377f"}[chunkId] + ".chunk.js";
};